import React from "react";
import { mockData } from "../data/mockData";
import { Facebook, Linkedin, Mail, Phone } from "lucide-react";

const Footer = ({ data }) => {
  const company = data?.companyInfo?.company || {
    name: "Reignite Health",
    tagline: "We put life in your years", 
    email: "hello@reignitehealth.com.au",
    phone: "0437 160 997"
  };
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { 
      icon: Facebook, 
      href: "https://www.facebook.com/101297699251310", 
      label: "Facebook" 
    },
    { 
      icon: Linkedin, 
      href: "https://www.linkedin.com/company/reignite-health", 
      label: "LinkedIn" 
    }
  ];

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-6xl mx-auto">
          
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            
            {/* Company Info */}
            <div className="space-y-6">
              <div className="text-2xl md:text-3xl font-light">
                reignite<span className="text-orange-500">health</span><span className="text-red-500">.</span>
              </div>
              <p className="text-white/70 font-light leading-relaxed">
                {company.tagline}
              </p>
              <p className="text-white/60 text-sm font-light">
                Specialising in retirement village healthcare and wellness services across NSW.
              </p>
            </div>

            {/* Quick Links */}
            <div className="space-y-6">
              <h4 className="text-lg font-light text-white">Quick Links</h4>
              <nav className="space-y-3">
                {[
                  { name: "About Us", href: "#about" },
                  { name: "Our Services", href: "#services" },
                  { name: "Our Impact", href: "#work" },
                  { name: "Contact", href: "#contact" }
                ].map((link) => (
                  <button
                    key={link.name}
                    onClick={() => {
                      const element = document.querySelector(link.href);
                      if (element) element.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="block text-white/60 hover:text-white transition-colors duration-300 text-sm font-light hover:translate-x-1 transform transition-transform"
                  >
                    {link.name}
                  </button>
                ))}
              </nav>
            </div>

            {/* Contact Info */}
            <div className="space-y-6">
              <h4 className="text-lg font-light text-white">Get In Touch</h4>
              <div className="space-y-4">
                <div className="flex items-center group">
                  <Phone className="w-4 h-4 text-red-500 mr-3 group-hover:scale-110 transition-transform duration-300" />
                  <a 
                    href={`tel:${company.phone}`}
                    className="text-white/70 hover:text-white transition-colors duration-300 text-sm font-light"
                  >
                    {company.phone}
                  </a>
                </div>
                <div className="flex items-center group">
                  <Mail className="w-4 h-4 text-red-500 mr-3 group-hover:scale-110 transition-transform duration-300" />
                  <a 
                    href={`mailto:${company.email}`}
                    className="text-white/70 hover:text-white transition-colors duration-300 text-sm font-light"
                  >
                    {company.email}
                  </a>
                </div>
              </div>

              {/* Social Links */}
              <div className="flex space-x-4 pt-4">
                {socialLinks.map((social) => {
                  const IconComponent = social.icon;
                  return (
                    <a
                      key={social.label}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="p-2 bg-white/5 rounded-lg hover:bg-red-500/20 transition-all duration-300 hover:scale-110 group"
                      aria-label={social.label}
                    >
                      <IconComponent className="w-5 h-5 text-white/60 group-hover:text-red-500 transition-colors duration-300" />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/10 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-white/50 text-sm font-light">
                Copyright © {currentYear} {company.name} - All Rights Reserved.
              </p>
              <div className="flex items-center space-x-6 text-xs text-white/40">
                <button className="hover:text-white/70 transition-colors duration-300 font-light">
                  Privacy Policy
                </button>
                <button className="hover:text-white/70 transition-colors duration-300 font-light">
                  Terms of Service
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;